<template>
  <div class="task_add--block">
    <div class="add-task">
      <div class="add-task__input">
        <input
          :disabled="get_flag_for_add_task"
          type="text"
          class="tasks_row"
          v-model="task_title"
          :placeholder="$t('task.add_task', { list_name: project_name })"
          @keyup.enter="addTask"
          ref="add_task"
          maxlength="160"
        />
        <p class="recur--button" @click="show_recur = !show_recur">
          {{ $t("recur.recurring") }}
        </p>
        <span>{{ task_title_length }}</span>
      </div>
    </div>
    <RecurForm
      v-if="show_recur"
      @change="recurFormChange"
      :show_form="show_recur"
      @keyPress:enter="addTask"
    ></RecurForm>
  </div>
</template>

<script>
import RecurForm from "./RecurForm.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { EventEmitter } from "../../main";
import moment from "moment";
import plan from "../../utils/plan";
import { isRecurEndBeforeStart } from "../../utils/recur";

export default {
  name: "AddTasks",
  props: {
    project_id: [String, Number],
    project_name: [String],
  },
  components: {
    RecurForm,
  },
  data() {
    return {
      task_title: "",
      project_id_local: "",
      task_title_length: 160,
      show_recur: false,
      recur_form_data: "",
    };
  },
  mounted() {
    this.$root.$on("onboard:createTask", () => {
      this.addTask();
    });
    if (this.$route.params.project_id) {
      this.project_id_local = this.$route.params.project_id;
      // localStorage.setItem('project_id', this.$route.params.project_id)
    } else {
      let projectID = localStorage.getItem("project_id");
      // console.log(localStorage.getItem('project_id'))
      this.project_id_local = projectID
        ? projectID
        : this.$route.params.project_id;
    }
  },
  methods: {
    ...mapMutations(["setMessage"]),
    ...mapActions(["add_task", "socket_add_task", "socket_change_order"]),
    addTask() {
      if (this.task_title.trim() != "") {
        this.task_title = this.task_title.trim().slice(0, 160);
        const tasks = [];

        if (this.getTasks[this.project_id_local]) {
          this.getTasks[this.project_id_local].forEach((e) => {
            if (e) {
              if (!e.parent && !e.section) {
                tasks.push(e);
              }
            }
          });
        }

        tasks.sort(function (a, b) {
          return a.order - b.order;
        });

        let order = [];
        let body = "";
        let task_id = this.$w_decrypt(this.getUserData._id);

        if (this.getUserData.new_task == true) {
          body = {
            name: this.task_title.trim(),
            project_id: this.project_id_local,
            order: 0,
            _id: task_id,
            assign: { user_id: false },
          };
        }

        if (this.getUserData.new_task == false) {
          if (tasks) {
            tasks.forEach((e) => {
              order.push(Number(e.order));
            });
          } else {
            order = 0;
          }

          body = {
            name: this.task_title.trim(),
            project_id: this.project_id_local,
            order: order == 0 ? 0 : Math.max.apply(null, order) + 1,
            _id: task_id,
            assign: {
              user_id: false,
            },
          };
        }

        setTimeout(() => {
          EventEmitter.$emit("changeTaskLength", {
            project_id: this.project_id_local,
          });
          if (this.show_recur) {
            let valid = [];

            if (
              this.recur_form_data.end_type == "on_date" &&
              (isNaN(this.recur_form_data.end_date) ||
                isRecurEndBeforeStart(
                  this.recur_form_data.start_date,
                  this.recur_form_data.end_date
                ))
            ) {
              valid.push(true);
            }

            if (
              this.recur_form_data.end_type == "after" &&
              this.recur_form_data.occurrences <= 0
            ) {
              valid.push(true);
            }

            if (
              this.recur_form_data.start_date == "" ||
              isNaN(this.recur_form_data.start_date)
            ) {
              valid.push(true);
            }

            if (this.recur_form_data && valid.length == 0) {
              this.socket_add_task(body);

              this.recur_form_data.list_id = this.project_id_local;
              this.recur_form_data.task_id = task_id;
              this.$socket.emit("IN_TaskRecur", this.recur_form_data);
              this.show_recur = false;
              this.task_title = "";
            }
          } else {
            this.socket_add_task(body);
            this.task_title = "";
          }
        }, 0);
      }
    },
    recurFormChange(e) {
      this.recur_form_data = e;
    },
    // Онбординг попросил фокус для этого списка («Add your first task»).
    // Запрос лежит в сторе, а не в событии: компонент может смонтироваться
    // уже после перехода на список.
    takeOnboardingFocus() {
      const listId = this.onboardingTaskFocus;
      if (!listId || String(listId) !== String(this.project_id_local)) return;
      this.$store.dispatch("clearOnboardingTaskFocus");
      this.$nextTick(() => this.$refs.add_task && this.$refs.add_task.focus());
    },
  },
  computed: {
    ...mapGetters(["getTasks", "getUserData", "get_flag_for_add_task"]),
    onboardingTaskFocus() {
      return this.$store.getters.getOnboardingTaskFocus || null;
    },
  },
  watch: {
    onboardingTaskFocus() {
      this.takeOnboardingFocus();
    },
    project_id_local() {
      this.takeOnboardingFocus();
    },
    get_flag_for_add_task(e) {
      if (!e) {
        setTimeout(() => {
          this.$refs.add_task.focus();
        }, 0);
      }
    },
    $route(to) {
      this.show_recur = false;
      this.task_title = "";
      this.project_id_local = this.$route.params.project_id;
      // localStorage.setItem('project_id', this.$route.params.project_id)
    },
    task_title(e) {
      this.task_title_length = 160 - this.task_title.length;
      if (e.length > 160) {
        this.task_title = e.slice(0, 160);
      }
    },
  },
};
</script>

<style>
/*
    Enter and leave animations can use different
    durations and timing functions.
    */
.slide-fade-enter-active {
  transition: all 0.1s;
}

.slide-fade-leave-active {
  transition: all 0.1s;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
}
</style>
